import React, { Component } from "react";
import { initializeApp } from "firebase/app";
import {
  getFirestore,
  collection,
  doc,
  query,
  where,
  orderBy,
  startAfter,
  limit,
  getDoc,
  getDocs,
  onSnapshot
} from "firebase/firestore";
import { db } from "./auth";

let poleInstance;
let poleNode = null;
let unsub = undefined;

class PoleData {
  constructor() {
    if (poleInstance) {
      throw new Error("DevideAddres Instance already created");
    }
    poleInstance = this;
  }
  /** Expoeted functions*/
  getInstance() {
    return this;
  }

  deinit() {
    if (unsub) {
      unsub();
      unsub = undefined;
    }
    poleNode = null;
  }

  async initService() {
    if (!poleNode || Object.keys(poleNode).length === 0) {
      await this.getAllPolesAPICall();
    }
  }

  async getAllPolesAPICall() {
    return new Promise((resolve, reject) => {
      if (!db()) {
        console.log("PoleDataService: db is null, aborting getAllPolesAPICall");
        resolve();
        return;
      }
      const poleQuery = query(collection(db(), "poles"));
      
      let isFirstLoad = true;
      if (poleNode === null) {
        poleNode = {};
      }

      const startTime = Date.now();
      unsub = onSnapshot(poleQuery, (snapshot) => {
        let addedCount = 0;
        let modifiedCount = 0;
        let removedCount = 0;

        snapshot.docChanges().forEach((change) => {
          if (change.type === "added") addedCount++;
          if (change.type === "modified") modifiedCount++;
          if (change.type === "removed") removedCount++;

          const record = change.doc.data();
          const docId = change.doc.id;
          
          if (change.type === "added" || change.type === "modified") {
            poleNode[record["uid"]] = {
              "data": record,
              "docId": docId,
            };
          } else if (change.type === "removed") {
            delete poleNode[record["uid"]];
          }
        });

        console.log(`[Poles Snapshot] Received ${snapshot.docChanges().length} changes: +${addedCount} added, ~${modifiedCount} modified, -${removedCount} removed`);

        if (isFirstLoad) {
          isFirstLoad = false;
          const timeTaken = Date.now() - startTime;
          console.log(`[PERF] Initial Poles Snapshot Fetch: ${timeTaken}ms (From Cache: ${snapshot.metadata.fromCache}). Total Poles Fetched: ${snapshot.size}`);
          resolve();
        }
      }, (error) => {
        console.error("Error fetching poles:", error);
        if (isFirstLoad) {
          isFirstLoad = false;
          reject(error);
        }
      });
    });
  }

  getPole(poleId) {
    if (!poleNode || typeof poleNode !== "object") {
      return null;
    }
    return poleNode[poleId]?.data ?? null;
  }


  getPolesBySLC(slcId) {
    var poleResult = [];
    for (const key in poleNode) {
      // console.log(`${key}: ${poleNode[key]}`);
      var pole = poleNode[key];
      if (pole != undefined) {
        if (pole.data.slc_id == slcId) {
          poleResult.push(pole.data);
        }
      }
    }
    return poleResult;
  }

  getPoleDocId(poleId) {
    for (const key in poleNode) {
      console.log(`${key}: ${poleNode[key]}`);
      var pole = poleNode[key];
      if (pole != undefined) {
        if (pole.data.uid == poleId) {
          return pole.docId;
        }
      }
    }
    return null;
  }

}

const PoleDataService = Object.freeze(new PoleData());
export default PoleDataService;